import { Grid, Skeleton } from "@mui/material";

import { Observation, ProductLink } from "../styles/ProductsStyles";
import type { ProductCard } from "./ProductsTypes";

export type ProductFooterProps = {
  data: ProductCard;
  gtmHandleClick: (planName: string, id: number) => void;
};

export function formatIof(iof: number | null) {
  if (iof === null) {
    return null;
  }

  return iof.toFixed(2).replace(".", ",");
}

export function ProductFooter({ data, gtmHandleClick }: Readonly<ProductFooterProps>) {
  const formattedIof = formatIof(data.iof);

  return (
    <>
      <Grid container sx={{ marginTop: "15px" }}>
        <ProductLink
          type="button"
          onClick={() => gtmHandleClick(data.title, data.id)}
          aria-label={`Clique aqui e saiba mais sobre o plano ${data.title}`}
        >
          Clique aqui e saiba mais
        </ProductLink>
      </Grid>

      <Grid container justifyContent="center">
        <Observation>
          *Acréscimo de IOF (
          {formattedIof ?? (
            <Skeleton
              component="span"
              variant="text"
              sx={{ display: "inline-flex", width: "24px" }}
              aria-label="Carregando IOF"
            />
          )}
          %)
        </Observation>
      </Grid>
    </>
  );
}

export default ProductFooter;